// extracted by mini-css-extract-plugin
export default {"productGrid":"l1-z","centerLink":"m1-z","productSection":"n1-z","item":"o1-z","ctaButton":"p1-z"};